export const ComoLlegar = () => {
    return (
        <div className="mt-12">
            <h2
                className="text-[2rem] sm:text-[2vw] font-display text-brand-red uppercase leading-none mb-6"
            >
                Cómo llegar
            </h2>

            <a href="https://www.google.com/maps/search/Uriarte+1658,+Palermo,+Buenos+Aires,+Argentina" target="_blank" rel="noopener noreferrer" className="flex items-center text-white font-semibold mb-8 hover:text-brand-red transition-colors cursor-pointer">
                <svg className="w-5 h-5 text-green-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
                Uriarte 1658
            </a>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Mapa */}
                <div className="bg-[#0f243f] border border-[#163050] rounded-lg overflow-hidden min-h-[300px]">
                    <iframe
                        src="https://www.google.com/maps/embed/v1/place?key=AIzaSyDD0A_A4kid_Ryaa6LcURdQpKHvanppLS0&q=Uriarte+1658,+Palermo,+Buenos+Aires,+Argentina&zoom=16"
                        width="100%"
                        height="100%"
                        style={{ border: 0, minHeight: 300 }}
                        allowFullScreen
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        className="w-full h-full"
                    />
                </div>

                {/* Medios de transporte */}
                <div className="bg-brand-red/10 rounded-lg p-6">
                    <h3 className="text-xl text-brand-red font-display mb-4">Medios de transporte</h3>
                    <ul className="space-y-4">
                        <li className="flex items-start">
                            <svg className="w-5 h-5 text-gray-400 mr-3 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" /></svg>
                            <div>
                                <div className="font-semibold text-white">Línea 55</div>
                                <div className="text-sm text-gray-400">Paradas sobre Uriarte y Thames</div>
                            </div>
                        </li>
                        <li className="flex items-start">
                            <svg className="w-5 h-5 text-gray-400 mr-3 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" /></svg>
                            <div>
                                <div className="font-semibold text-white">Línea 111</div>
                                <div className="text-sm text-gray-400">Cnel. Niceto Vega y Thames</div>
                            </div>
                        </li>
                        <li className="flex items-start">
                            <svg className="w-5 h-5 text-gray-400 mr-3 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" /></svg>
                            <div>
                                <div className="font-semibold text-white">Líneas 34 / 166</div>
                                <div className="text-sm text-gray-400">Av. Juan B. Justo</div>
                            </div>
                        </li>
                        <li className="flex items-start">
                            <svg className="w-5 h-5 text-gray-400 mr-3 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" /></svg>
                            <div>
                                <div className="font-semibold text-white">Línea 39</div>
                                <div className="text-sm text-gray-400">Jorge Luis Borges / Av. Córdoba</div>
                            </div>
                        </li>
                        <li className="flex items-start">
                            <svg className="w-5 h-5 text-gray-400 mr-3 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" /></svg>
                            <div>
                                <div className="font-semibold text-white">Subte - Línea B</div>
                                <div className="text-sm text-gray-400">Estación Malabia</div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
};
